import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { OperonLogo } from "@/components/OperonLogo";
import { useTheme } from "@/lib/theme";
import { Button } from "@/components/ui/button";
import { Moon, Sun, ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  const { theme, toggleTheme } = useTheme();
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    api.get("/settings/privacy-policy").then(({ data }) => setDoc(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-dvh bg-background" data-testid="privacy-policy-page">
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <OperonLogo theme={theme} size={30} />
          </Link>
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="icon" onClick={toggleTheme}>
              {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </Button>
            <Button asChild variant="ghost" size="sm">
              <Link to="/"><ArrowLeft className="w-4 h-4 mr-1" /> Back</Link>
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight">Privacy Policy</h1>
        {doc?.updated && <div className="text-xs text-muted-foreground mt-2">Last updated: {doc.updated}</div>}
        <div className="mt-6 prose prose-sm max-w-none">
          {(doc?.sections || []).map((s, idx) => (
            <section key={idx} className="mt-6">
              <h2 className="font-heading text-lg font-semibold">{s.heading}</h2>
              <p className="text-sm leading-6 text-foreground/90 mt-1 whitespace-pre-wrap">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
